import { createAsyncThunk } from '@reduxjs/toolkit';
import { ErrorToast, SuccessToast } from '../../components';
import { setUserRegisterToLS } from '../../helpers/localstorage-helper';
import { PASSWORD } from '../../routes/routes';
import {
  addEmailAndVerificationCodeAsync,
  addEmailToNewTeamMemberAsync
} from './EmailAddress.requests';

interface AddEmailToNewTeamMemberType {
  parentId: number;
  childPosition: number;
  email: string;
  history: any;
}

export const addEmailToNewTeamMember = createAsyncThunk(
  'auth/addEmailToNewTeamMember',
  async (
    { parentId, childPosition, email, history }: AddEmailToNewTeamMemberType,
    { rejectWithValue, getState }
  ) => {
    try {
      const { data } = await addEmailToNewTeamMemberAsync(
        parentId,
        childPosition,
        email
      );
      const user = {
        user: data.data.user,
        referrerId: data.data.user.referrerId
      };

      setUserRegisterToLS(user);
      SuccessToast(data.message);

      history.push(PASSWORD);

      return user;
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);

interface AddEmailAndVerificationCodeType {
  approvalDate: string;
  referrerId: number;
  email: string;
  result: any;
  history: any;
}

export const addEmailAndVerificationCode = createAsyncThunk(
  'auth/addEmailAndVerificationCode',
  async (
    {
      approvalDate,
      referrerId,
      email,
      result,
      history
    }: AddEmailAndVerificationCodeType,
    { rejectWithValue }
  ) => {
    try {
      const { data } = await addEmailAndVerificationCodeAsync(
        approvalDate,
        referrerId,
        email,
        result
      );
      const user = {
        user: data.data.user,
        referrerId: data.data.user.referrerId
      };
      setUserRegisterToLS(user);
      SuccessToast(data.message);
      history.push(PASSWORD);
      return user;
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);
